export function useSignatureStore() {
  const isSignaturePage = useState<boolean>('is-signature-page', () => false)

  function setIsSignaturePage(value: boolean) {
    isSignaturePage.value = value
  }

  return {
    isSignaturePage,
    setIsSignaturePage,
  }
}
